import { Button, type ButtonVariant } from '@/app/common/Buttons/Button';
import { cn, getButtonVariant, shouldOpenInNewTab } from '@workspace/lib';
import { stripInvisibles } from '@workspace/constants';
import { pageApplicationsVariants } from '@workspace/blocks/PageApplications/applications.variants';
import type { ApplicationsBlockButton } from '../application.types';

export const renderButtons = (buttons: ApplicationsBlockButton[] | undefined) => {
  if (!buttons?.length) return null;
  const { buttonGroup, button } = pageApplicationsVariants();

  return (
    <div className={cn('flex flex-wrap', buttonGroup())}>
      {buttons.map((btn, idx) => {
        const variant: ButtonVariant = getButtonVariant(btn.style);
        const label = stripInvisibles(btn.label || 'Button').trim() || 'Button';

        if (!btn?.link?.url) {
          return (
            <Button
              key={idx}
              isDisabled
              variant={variant}
              className={button()}
              openInNewTab={shouldOpenInNewTab(btn?.link)}
            >
              {label}
            </Button>
          );
        }

        return (
          <Button
            key={idx}
            variant={variant}
            url={btn?.link?.url}
            openInNewTab={shouldOpenInNewTab(btn?.link)}
            className={button()}
          >
            {label}
          </Button>
        );
      })}
    </div>
  );
};
